import { z } from 'zod';
import { localeCodeSchema } from './i18n.js';
/**
 * docs/004 requires closed sets be enums but never names these members.
 * Chosen here and recorded in docs/adr/0014-user-and-membership-status-enums.md.
 * The Prisma enums in packages/db must stay identical to these lists.
 */
export const USER_STATUSES = ['PENDING', 'ACTIVE', 'SUSPENDED'];
export const userStatusSchema = z.enum(USER_STATUSES);
export const PLATFORM_ROLES = ['SUPERADMIN', 'SUPPORT'];
export const platformRoleSchema = z.enum(PLATFORM_ROLES);
/**
 * A `User` is a global identity, NOT a `Person` (docs/004's cardinal rule — the two are
 * never merged). Credentials are absent by construction: the identity provider owns them,
 * and the DTO could not expose them even if a column existed.
 */
export const userDTOSchema = z.object({
    id: z.string().min(1),
    email: z.string().email(),
    name: z.string().min(1),
    status: userStatusSchema,
    preferredLocale: localeCodeSchema,
    isPlatformOperator: z.boolean(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=user.js.map